<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import http from "@/utils/http";
import router from "@/router";
import {delay} from "@/utils/function";

export default {
  name: 'App',

  data() {

    return {
      user: null,
    }

  },
  created() {


    chrome?.webview?.addEventListener('message', this.handleMessage);


    this.getLiveMessage();

  },
  provide() {

    return {
      down: this.down,
      up: this.up,
      eSend: this.eSend,
      getUser: this.getUser,
      getPlatform: this.getPlatform,
      connectWs: this.connectWs,
      stopWs: this.stopWs,
      timer: null,
    }

  },
  computed: {
    storeWs() {
      return this.$store.getters.ws;
    }
  },


  methods: {
    getLiveMessage() {

      setInterval(async () => {
        const res = await http.post("api/platform/getLiveMessage", {
          keyPop: this.$store.getters.keyPop,
          keyReply: this.$store.getters.keyReply,
          keyReplyGroup: this.$store.getters.keyReplyGroup,
          keyReplyAt: this.$store.getters.keyReplyAt
        });

        if (res.code === 200 && Array.isArray(res.data)) {
          window.dispatchEvent(new CustomEvent('live-message', {
            detail: res.data
          }));
        }
      }, 5000)


    },
    handleMessage({data}) {
      const type = data.type;
      switch (type) {
        case "message":
          this.$message[data.icon](data.msg)
          break;
      }
    },
    down() {
      this.timer = setTimeout(() => {
        // 长按逻辑
        this.eSend("startMove")
      }, 150)

    },
    up() {
      clearTimeout(this.timer)
    },

    eSend(type, data = {}) {
      try {
        window.chrome.webview.postMessage({type, data})
      } catch (e) {
      }
    },
    async getPlatform() {
      const res = await http.get("api/platform/get");
      if (res.code == 200) {
        this.$store.dispatch("setPlatform", res.data);
      }


    },
    connectWs(web_rid) {
      if (this.storeWs) {
        this.stopWs();
      }
      const ws = new WebSocket("wss://" + location.host + "/dy/" + web_rid);
      this.$store.dispatch("setWs", ws);
    },
    stopWs() {

      if (this.storeWs) {

        this.storeWs.close();
        this.$store.dispatch("setWs", null)

      }

    },


    async getUser() {


      const res = await http.get("api/user/info");
      if (res.code == 200) {
        this.$store.dispatch("setUser", res.data);
        await delay(30000)
        this.getUser();
      }

    }

  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  user-select: none;
}

*::-webkit-scrollbar {
  display: none;
}

</style>